import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { ClientCache } from '@xanadu/cache';
import { Client } from '@xanadu/model';
import { PickerComponent } from '../picker/picker.component';

@Component({
    selector: 'app-client-picker',
    templateUrl: './client-picker.component.html',
    styleUrls: ['./client-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClientPickerComponent extends PickerComponent<Client> {
    private readonly clientCache = inject(ClientCache);

    constructor() {
        super();

        effect(() => {
            const clients = this.clientCache.signal();

            if (clients) {
                this.items.set([...clients.values()]);
            }
        });
    }

    protected filter(client: Client): boolean {
        return true;
    }
}
